export const queryKeys = {
  auth: {
    me: ['auth', 'me']
  },
  groups: {
    byId: (id) => ['groups', 'byId', String(id)]
  },
  feed: {
    list: (params = {}) => ['feed', 'list', params],
    weather: (regionIds = []) => ['feed', 'weather', regionIds],
    quizList: ['feed', 'quiz', 'list'],
    quizDetail: (id) => ['feed', 'quiz', 'detail', String(id)],
    profiwayList: ['feed', 'profiway', 'list'],
    profiwayDetail: (id) => ['feed', 'profiway', 'detail', String(id)],
    newsList: (params = {}) => ['feed', 'news', 'list', params],
    newsDetail: (id) => ['feed', 'news', 'detail', String(id)],
    halykUserInfo: ['feed', 'halyk', 'user-info']
  },
  careerGuide: {
    performance: (uin) => ['careerGuide', 'performance', String(uin || '')],
    sections: (uin) => ['careerGuide', 'sections', String(uin || '')],
    edaryn: (uin) => ['careerGuide', 'edaryn', String(uin || '')],
    recommendations: (uin) => ['careerGuide', 'recommendations', String(uin || '')],
  },
  videoCourse: {
    catalog: (lang) => ['videoCourse', 'catalog', String(lang || 'ru')],
    courses: (fallback) => ['videoCourse', 'courses', String(fallback || '')],
    subjects: (courseId, fallback) => ['videoCourse', 'subjects', Number(courseId || 0), String(fallback || '')],
    videos: (filters = {}, fallback) => [
      'videoCourse',
      'videos',
      {
        course_id: Number(filters?.course_id || 0),
        subject_id: Number(filters?.subject_id || 0),
        fallback: String(fallback || '')
      }
    ]
  },
  periods: {
    list: (params = {}) => ['periods', 'list', params]
  },
  schedule: {
    raspisanie: (ts, groupId, pupilId) => ['schedule', 'raspisanie', Number(ts || 0), Number(groupId || 0), Number(pupilId || 0)],
    bells: () => ['schedule', 'bells'],
    plans: (startTs, endTs, groupId) => ['schedule', 'plans', Number(startTs || 0), Number(endTs || 0), Number(groupId || 0)],
    marks: (startTs, endTs, pupilId) => ['schedule', 'marks', Number(startTs || 0), Number(endTs || 0), Number(pupilId || 0)]
  },
  childMenu: {
    meals: (dateTs, type) => ['childMenu', 'meals', Number(dateTs || 0), String(type ?? '')],
    marks: (monthTs) => ['childMenu', 'marks', Number(monthTs || 0)],
    chat: (page) => ['childMenu', 'chat', Number(page || 0)]
  },
  gradesRating: {
    assignments: (groupId) => ['gradesRating', 'assignments', Number(groupId || 0)],
    marks: (startTs, endTs, pupilId) => ['gradesRating', 'marks', Number(startTs || 0), Number(endTs || 0), Number(pupilId || 0)],
    average: (quarter, pupilId) => ['gradesRating', 'average', Number(quarter || 0), Number(pupilId || 0)]
  },
  reportCard: {
    quarter: (pupilId) => ['reportCard', 'quarter', Number(pupilId || 0)],
    annual: (pupilId) => ['reportCard', 'annual', Number(pupilId || 0)],
    exam: (pupilId) => ['reportCard', 'exam', Number(pupilId || 0)],
    final: (pupilId) => ['reportCard', 'final', Number(pupilId || 0)],
    parallels: (pupilId) => ['reportCard', 'parallels', Number(pupilId || 0)],
    subjectsByIds: (ids = []) => ['reportCard', 'subjects', [...ids].map((id) => Number(id || 0)).sort((a, b) => a - b)]
  },
  calendar: {
    plans: (startTs, endTs, groupId) => ['calendar', 'plans', Number(startTs || 0), Number(endTs || 0), Number(groupId || 0)],
    marks: (startTs, endTs, pupilId) => ['calendar', 'marks', Number(startTs || 0), Number(endTs || 0), Number(pupilId || 0)],
    holidays: (startTs, endTs) => ['calendar', 'holidays', Number(startTs || 0), Number(endTs || 0)],
    subjectsByIds: (ids = []) => ['calendar', 'subjects', [...ids].map((id) => Number(id || 0)).sort((a, b) => a - b)]
  },
  allTasks: {
    plans: (startTs, endTs, groupId, pupilId) => [
      'allTasks',
      'plans',
      Number(startTs || 0),
      Number(endTs || 0),
      Number(groupId || 0),
      Number(pupilId || 0)
    ]
  },
  task: {
    tasks: (lessonId, pupilId) => ['task', 'tasks', Number(lessonId || 0), Number(pupilId || 0)],
    materials: (lessonId, roleId, pupilId) => ['task', 'materials', Number(lessonId || 0), Number(roleId || 0), Number(pupilId || 0)],
    tests: (lessonId, pupilId) => ['task', 'tests', Number(lessonId || 0), Number(pupilId || 0)],
    sdotToken: (serverId, pupilId) => ['task', 'sdotToken', String(serverId || ''), Number(pupilId || 0)]
  },
  settings: {
    pushTokenState: (token, userId) => ['settings', 'pushTokenState', String(token || ''), Number(userId || 0)]
  }
};
